import { render, staticRenderFns } from "./AddDeleteButton.vue?vue&type=template&id=f7061fdc"
import script from "./AddDeleteButton.vue?vue&type=script&lang=ts"
export * from "./AddDeleteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports